import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './assets/css/style.css'
import Cookies from 'js-cookie'
 
Vue.config.productionTip = false

const ClickOutside = {  //custom directive that allows to assign global click handler which will only be executed outside of element
  bind: function(el, binding, vnode){
    el.clickOutsideEvent = function(event){
      if(el == event.target) return;
      if(el.contains(event.target)) return;
      if(vnode.hasOwnProperty(binding.expression)) vnode.context[binding.expression](event, el);  //event handler is method of the component
      else if(typeof binding.value === 'function') binding.value.bind(vnode.context)(event, el);  //event handler is provided as anonymous function
      else (function(){ eval(binding.expression); }).call(vnode.context);  //execute expression in component context
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function(el){
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
}

Vue.directive('click-outside', ClickOutside);

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')

i18n.locale = Cookies.get('lang') ? Cookies.get('lang') : 'en';